<template>
  <div>
    <!-- Withdraw Logs Modal -->
    <div
      class="modal fade"
      id="withdraw-log-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h4 class="modal-title text-white text-bold">Withdraw Logs</h4>
          </div>
          <div class="modal-footer bg-white shadow">
            <div class="row">
              <div class="col-md-12 mb-5">
                <v-select
                  class="fabric-selector"
                  label="production_name"
                  placeholder="Select a Fabric"
                  @input="search"
                  :multiple="true"
                  v-model="params.fabricIds"
                  :options="allFabrics"
                  :reduce="(allFabrics) => allFabrics.id"
                />
              </div>
              <div class="col-md-4">
                <datepicker
                  :clear-button="true"
                  @input="search"
                  placeholder="Select Date"
                  v-model="params.from"
                  input-class="form-control"
                >
                </datepicker>
              </div>
              <div class="col-md-4">
                <datepicker
                  :clear-button="true"
                  @input="search"
                  placeholder="Select Date"
                  v-model="params.to"
                  input-class="form-control"
                >
                </datepicker>
              </div>
              <div class="col-md-4">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body logs-view">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Fabric</th>
                  <th>Roll Id</th>
                  <th class="text-right">Length</th>
                  <th class="text-center">Withdraw Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="roll in rolls" :key="roll.id">
                  <td>
                    {{ $Fabric.getCode(roll.fabric_id) }} - {{ roll.name }}
                  </td>
                  <td>
                    {{ roll.roll_code }}
                  </td>
                  <td class="text-right">
                    {{ ezy.comma(roll.length) }}
                    <span class="text-capitalize">
                      {{ roll.unit }}
                    </span>
                  </td>
                  <td class="text-center">
                    {{ moment(roll.date_in_use).format("DD MMM, YYYY") }}
                  </td>
                </tr>
                <tr v-if="rolls.length == 0">
                  <td colspan="4" class="text-center">NO DATA</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Datepicker from "vuejs-datepicker";
export default {
  props: ["allFabrics"],
  components: {
    Datepicker,
  },
  data() {
    return {
      rolls: [],
      params: {
        from: moment().format(),
        to: moment().format(),
        fabricIds: null,
      },
    };
  },
  methods: {
    async search() {
      try {
        let res = await axios.get("v2/fabrics/withdrawal/logs", {
          params: this.params,
        });
        this.rolls = res.data.data;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },
  },
};
</script>

<style scoped>
.logs-view {
  height: 600px;
  overflow: scroll;
  background: #5e71e400;
}
.logs-view tr:hover {
  background: #5e71e447;
}
</style>
